import { render } from "./LocalFields.vue?vue&type=template&id=52df2dcf&ts=true"
import script from "./LocalFields.vue?vue&type=script&lang=ts"
export * from "./LocalFields.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__